/* eslint-disable react/display-name */
import React, { ReactNode } from 'react';

export interface IModalStatusProps {
    id?: string;
    children?: ReactNode | ReactNode[];
}

export function ModalStatus(props: IModalStatusProps) {
    const { id } = props;
    return (
        <div className="modal-status" id={`modal-status-${id}`}>
            {props.children}
        </div>
    );
}
